var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 2H3.6C3.30826 2 3.02847 2.11589 2.82218 2.32218C2.61589 2.52847 2.5 2.80826 2.5 3.1V20.9C2.5 21.0445 2.52845 21.1875 2.58373 21.321C2.63901 21.4544 2.72004 21.5757 2.82218 21.6778C2.92433 21.78 3.04559 21.861 3.17905 21.9163C3.31251 21.9715 3.45555 22 3.6 22H13.18V14.25H10.58V11.25H13.18V9C13.1261 8.47176 13.1885 7.93813 13.3627 7.43654C13.5369 6.93495 13.8188 6.47755 14.1885 6.09641C14.5582 5.71528 15.0068 5.41964 15.5028 5.23024C15.9989 5.04083 16.5304 4.96225 17.06 5C17.8383 4.99521 18.6163 5.03528 19.39 5.12V7.82H17.8C16.54 7.82 16.3 8.42 16.3 9.29V11.22H19.3L18.91 14.22H16.3V22H21.4C21.5445 22 21.6875 21.9715 21.821 21.9163C21.9544 21.861 22.0757 21.78 22.1778 21.6778C22.28 21.5757 22.361 21.4544 22.4163 21.321C22.4715 21.1875 22.5 21.0445 22.5 20.9V3.1C22.5 2.95555 22.4715 2.81251 22.4163 2.67905C22.361 2.54559 22.28 2.42433 22.1778 2.32218C22.0757 2.22004 21.9544 2.13901 21.821 2.08373C21.6875 2.02845 21.5445 2 21.4 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.32c4969d48933e2913447c529da21704.svg";
export { ForwardRef as ReactComponent };